import React from 'react'
import { Link } from "react-router-dom";


const FAQ = () => {
    return (
        <>
            <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
                <div className="container">
                    <div className="row">
                        <div className="page-heading">
                            <h2 className="wow fadeInUp" data-wow-delay=".3s">FAQ's</h2>
                            <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li><i className="fa-solid fa-chevron-right" /></li>
                                <li>FAQ's</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>


            <section className="faq-section section-padding">
                <div className="container">
                    <div className="section-title-area">
                        <div className="section-title">
                            <span className="sub-title wow fadeInUp">Frequently Asked Questions</span>
                            {/* <h2 className="wow fadeInUp" data-wow-delay=".3s">
                                Looking For Answers?
                            </h2> */}
                        </div>
                        {/* <p className="wow fadeInUp" data-wow-delay=".5s">
                            They are bought and sold online, frequently with cryptocurrency, and they <br /> are generally encoded
                            with the same underlying.
                        </p> */}
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="faq-items">
                                <div className="faq-accordion">
                                    <div className="accordion" id="accordion2">
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".3s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq1" aria-expanded="false" aria-controls="faq1">
                                                    What curriculum does Saraswati Vidyapeeth Higher Secondary School follow? 
                                                </button>
                                            </h5>
                                            <div id="faq1" className="accordion-collapse show" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    Saraswati Vidyapeeth Higher Secondary School follows the Madhya Pradesh Board of Secondary Education curriculum, providing a well-rounded education that integrates academics, sports, arts, and life skills.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".1s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2" aria-expanded="true" aria-controls="faq2">
                                                    What are the admission criteria at Saraswati Vidyapeeth Higher Secondary School?
                                                </button>
                                            </h5>
                                            <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    <b>Admission is based on:</b>

                                                    <li> Age eligibility as per Madhya Pradesh Board of Secondary Education norms.</li>
                                                    <li>Submission of required documents (birth certificate, previous school records, etc.).</li>
                                                    <li> Entrance tests or interaction sessions (for higher classes).</li>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".6s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3" aria-expanded="false" aria-controls="faq3">
                                                    What are the school timings?
                                                </button>
                                            </h5>
                                            <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    Pre-Primary & Primary, Middle & Senior School: 08:00 AM - 03:45 PM
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".5s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq4" aria-expanded="false" aria-controls="faq4">
                                                    What languages are offered at Saraswati Vidyapeeth Higher Secondary School?
                                                </button>
                                            </h5>
                                            <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    <b>Parents can reach out via:</b>
                                                    <li>End of Session TC: Apply before 31st December to receive the TC by the session’s end.</li>
                                                    <li>Mid-Term TC: A three-month advance notice is required to process the TC and be eligible for a security deposit refund.</li>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".5s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq5" aria-expanded="false" aria-controls="faq5">
                                                    What co-curricular activities are available?
                                                </button>
                                            </h5>
                                            <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    <b>We focus on holistic development with activities such as:</b>
                                                    <li>Sports & Physical Education (football, basketball, yoga, etc.)</li>
                                                    <li> Art, Music, & Dance</li>
                                                    <li> Public Speaking, Debate, & Drama</li>
                                                    <li>STEM & Robotics Programs</li>
                                                    <li> Community Service & Leadership Initiatives</li>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item wow fadeInUp" data-wow-delay=".5s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq6" aria-expanded="false" aria-controls="faq6">
                                                    How does the school assess students’ progress?
                                                </button>
                                            </h5>
                                            <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    <b>We focus on holistic development with activities such as:</b>
                                                    <p>Saraswati Vidyapeeth Higher Secondary School follows the Madhya Pradesh Board of Secondary Education Continuous and Comprehensive Evaluation system, which includes:</p>
                                                    <li> Periodic Assessments & Term Exams</li>
                                                    <li> Project Work & Practical Learning</li>
                                                    <li> Internal & External Competitions</li>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="faq-items">
                                <div className="faq-accordion">
                                    <div className="accordion" id="accordion3">
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".3s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq7" aria-expanded="true" aria-controls="faq7">
                                                    What is the student-teacher ratio at Saraswati Vidyapeeth Higher Secondary School?
                                                </button>
                                            </h5>
                                            <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    We maintain a low student-teacher ratio to ensure personalized attention and effective learning.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".5s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq8" aria-expanded="true" aria-controls="faq8">
                                                    Does the school provide transport facilities?
                                                </button>
                                            </h5>
                                            <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    Yes, we offer safe and reliable school transport with GPS tracking and trained staff.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".5s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq9" aria-expanded="false" aria-controls="faq9">
                                                    Does Saraswati Vidyapeeth Higher Secondary School offer career counseling?
                                                </button>
                                            </h5>
                                            <div id="faq9" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    Yes, we provide career guidance and counseling sessions for students in higher classes to help them explore academic and career pathways.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".5s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq10" aria-expanded="false" aria-controls="faq10">
                                                    How does the school ensure student safety?
                                                </button>
                                            </h5>
                                            <div id="faq10" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    <li> CCTV surveillance & trained security personnel</li>
                                                    <li> Strict visitor verification protocols</li>
                                                    <li> Health & hygiene measures, including a school infirmary</li>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".5s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq11" aria-expanded="false" aria-controls="faq11">
                                                    Is there a uniform policy at Saraswati Vidyapeeth Higher Secondary School?
                                                </button>
                                            </h5>
                                            <div id="faq11" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    Yes, students are required to follow the school’s prescribed uniform policy, details of which are provided upon admission.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mb-3 wow fadeInUp" data-wow-delay=".5s">
                                            <h5 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq12" aria-expanded="false" aria-controls="faq12">
                                                    How can parents communicate with the school?
                                                </button>
                                            </h5>
                                            <div id="faq12" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                <div className="accordion-body">
                                                    <b>Parents can reach out via:</b>
                                                    <li>School office contact number & email</li>
                                                    <li> Parent-Teacher Meetings (PTMs)</li>
                                                    <li> School’s online portal for updates & queries</li>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




        </>
    )
}

export default FAQ